import React, { useEffect, useState } from 'react';
import { getSettings } from '../../util/getSettings';
import { filterDefaults } from '../../util/filters';
import Slider from '../shared/slider';

const SquareFeet = ({ minFeet, maxFeet, onChange }) => {
  const [selectedMinFeet, setSelectedMinFeet] = useState(null);
  const [selectedMaxFeet, setSelectedMaxFeet] = useState(null);
  const labels = getSettings(['century', 'labels'], true);

  useEffect(() => {
    setSelectedMinFeet(minFeet);
    setSelectedMaxFeet(maxFeet);
  }, [minFeet, maxFeet]);

  const onSliderChange = (sliderValues) => {
    const _minFeet = sliderValues.selectedMin;
    const _maxFeet = sliderValues.selectedMax;
    setSelectedMinFeet(_minFeet);
    setSelectedMaxFeet(_maxFeet);
    onChange(_minFeet, _maxFeet);
  };

  return (
    <Slider
      title={labels.squareFeetLabel}
      minValue={filterDefaults.minSquareFeet}
      maxValue={filterDefaults.maxSquareFeet}
      selectedMinValue={selectedMinFeet}
      selectedMaxValue={selectedMaxFeet}
      minInputLabel={labels.minSquareFeetLabel}
      maxInputLabel={labels.maxSquareFeetLabel}
      onSliderChange={onSliderChange}
      step={100}
    />
  );
};

export default SquareFeet;
